import { useState } from 'react';
import styles from './styles.module.scss';
import Link from 'next/link';

export function Cities({ locations, cities }) {
	const [showAll, setShowAll] = useState(false);
	const initialCitiesToShow = 8;
	const uniqueCitiesSet = new Set();

	cities.forEach((city) => {
		uniqueCitiesSet.add(city.toLowerCase());
	});

	const uniqueCities = Array.from(uniqueCitiesSet).sort();

	return (
		<>
			<div className={styles.list}>
				<h2>Cities We Deliver To</h2>
				{uniqueCities.length > 0 ? (
					<ul className="auto-grid" role="list">
						{(showAll
							? uniqueCities
							: uniqueCities.slice(0, initialCitiesToShow)
						).map((city) => (
							<Link
							href={`/weed-delivery/${city.replace(/\s+/g, '-').toLowerCase()}`}
							key={city}
							style={{ textTransform: "capitalize" }}
							className="link"
							>
								<li key={city} style={{ textTransform: "capitalize" }}>{city}</li>
							</Link>
						))}
					</ul>
				) : null}
				{uniqueCities.length > initialCitiesToShow && (
					<button
						className="button"
						data-type="text"
						onClick={() => setShowAll(!showAll)}
					>
						{showAll ? "Show Less -" : "Show All +"}
					</button>
				)}
			</div>
		</>
	);
}